<div class="modal-header">
  <h4 class="modal-title">{{'editProjectOptionPopup.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">{{'editProjectOptionDefPopup.label_optionName' | translate}}: </label>
        <div class="col-md-9">
          <input type="text"
                 spellcheck="false"
                 class="form-control"
                 (keydown.enter)="onSave()"
                 [class.is-invalid]="!form.controls.optionName.valid"
                 formControlName="optionName"
                 appInputAutoFocus autofocus>
          <div class="invalid-feedback">{{form.controls.optionName.errors?.messageKey | translate: {'0': form.controls.optionName.errors?.param} }}</div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="onSave()">{{'global.label.apply' | translate}}</button>
</div>
